<template>
    <DCard padding>
        <DCol>
            <DRow
                class="mb-3"
                vertical-align="end"
            >
                <DCol
                    sm="10"
                    class="pt-1"
                >
                    <div>
                        <span>{{ __('customers.customers.search.search') }}: </span>
                        <strong>{{ customers.total }} {{ __('customers.customers.search.result_customer_count') }}</strong>
                    </div>
                    <DTag
                        v-for="(value, key) in filters.search"
                        :key="key"
                        :label="key + ': ' + value"
                        color="primary"
                        style="cursor: pointer; margin-right: .5rem"
                        @click="removeFilter(key)"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="text-right"
                >
                    <DButton
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
        <DTable
            :fields="fields"
            :items="customers.data"
            :sorter="isSortable"
            :sorter-value="sorterValue"
            @update:sorter-value="updateOrdering"
        >
            <template #firstname="{item}">
                <td>
                    {{ removeEmpty(item.firstname) }}
                </td>
            </template>
            <template #lastname="{item}">
                <td>
                    {{ removeEmpty(item.lastname) }}
                </td>
            </template>
            <template #company="{item}">
                <td>
                    {{ removeEmpty(item.company) }}
                </td>
            </template>
            <template #email="{item}">
                <td>
                    {{ removeEmpty(item.email) }}
                </td>
            </template>
            <template #id="{item}">
                <td>
                    <Link :href="$route('customers.customers.show', {customer: item.id})">
                        {{ item.id }}
                    </Link>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            icon="eye"
                            mini
                            @click="$inertia.get($route('customers.customers.show', {customer: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('customer.edit')"
                            icon="pencil"
                            mini
                            @click="$inertia.get(editCustomerLink(item.id))"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="customers.last_page > 1"
            class="pb-2"
            :active-page="customers.current_page"
            :pages="customers.last_page"
            align="center"
            @update:activePage="changePage"
        />
    </DCard>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
    name: 'CustomerSearchIndex',
    components: {
        Link
    },
    props: {
        customers: {
            type: Object,
            default: () => { return {} }
        },
        filters: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            fields: [
                { key: 'id', label: this.__('customers.customers.customer_id'), sorter: true },
                { key: 'firstname', label: this.__('customers.common.firstname'), sorter: false },
                { key: 'lastname', label: this.__('customers.common.lastname'), sorter: false },
                { key: 'company', label: this.__('customers.common.company'), sorter: false },
                { key: 'email', label: this.__('customers.common.email'), sorter: false },
                { key: 'actions', label: '', sorter: false, filter: false }
            ],
            filterParams: {
                order_by: this.filters.order_by,
                order_by_asc: this.filters.order_by_asc ? 1 : 0
            }
        }
    },
    computed: {
        sorterValue () {
            return {
                column: this.filterParams.order_by,
                asc: !!this.filters.order_by_asc
            }
        },
        isSortable () {
            if (!this.sorterValue.column) return false

            return { external: true }
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        editCustomerLink (id) {
            return this.$route('customers.customers.edit', id)
        },
        removeEmpty (value) {
            return value || ''
        },
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.filterParams).filter(([_, v]) => v))

            for (const propName in this.filters.search) {
                queryParameters[propName] = this.filters.search[propName]
            }

            if (page !== 1) {
                queryParameters._query = { page: page }
            }

            this.$inertia.get(this.$route('customers.customers.advanced-search.show', queryParameters))
        },
        removeFilter (key) {
            delete this.filters.search[key]
            this.changePage(1)
        },
        updateOrdering (event) {
            this.filterParams.order_by = event.column
            this.filterParams.order_by_asc = event.asc ? 1 : 0

            this.changePage(this.customers.current_page)
        },
        resetFilters () {
            this.$inertia.get(this.$route('customers.customers.advanced-search.index', { page: this.customers.current_page }))
        }
    }
}
</script>
